<template>
  <div>
    <div id="particles-bg">
      <particles-bg color="#f7941e" num="7" type="cobweb" :bg="true" />
    </div>
    <Content
      :title="contents[0].title"
      :description="contents[0].description"
    ></Content>
    <div class="container">
      <div class="row" id="cards">
        <div class="col-sm-6 d-flex justify-content-center text-center">
          <div id="services" class="card" style="width: 18rem">
            <img
              class="card-img-top"
              src="../assets/team_as_a_service.svg"
              alt="Card image cap"
            />
            <div class="card-body">
              <h3 class="card-text">Team as a Service</h3>
            </div>
          </div>
        </div>
        <div class="col-sm-6 d-flex justify-content-center text-center">
          <div id="services" class="card" style="width: 18rem">
            <img
              class="card-img-top"
              src="../assets/outsourcing.svg"
              alt="Card image cap"
            />
            <div class="card-body">
              <h3 class="card-text">Outsourcing</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img class="circle" src="../assets/circle.svg" alt="" />
    <div id="title_TAS">
      <Content
        :title="contents[1].title"
        :description="contents[1].description"
      ></Content>
    </div>
    <img class="circle" src="../assets/circle.svg" alt="" />
    <div id="title_OUT">
      <Content
        :title="contents[2].title"
        :description="contents[2].description"
      ></Content>
    </div>
    <div class="row col-sm-12" id="typesOutsourcing">
      <div
        class="col-sm-6 col-centered d-flex justify-content-center text-center"
      >
        <div id="outsourcing" class="card" style="width: 25rem">
          <h3 class="card-title">{{ contents[3].title }}</h3>
          <div
            class="card-body align-items-center d-flex justify-content-center"
          >
            <p class="card-text" v-html="contents[3].description"></p>
          </div>
        </div>
      </div>
      <div class="vl"></div>
      <hr id="split" />
      <div
        class="col-sm-6 col-centered d-flex justify-content-center text-center"
      >
        <div id="outsourcing" class="card" style="width: 25rem">
          <h3 class="card-title">{{ contents[4].title }}</h3>
          <div class="card-body align-items-center">
            <p class="card-text" v-html="contents[4].description"></p>
          </div>
        </div>
      </div>
    </div>
    <span v-if="this.contents2.length !== 0">
      <img class="circle" src="../assets/circle.svg" alt=""/>
      <div v-for="content in contents2" :key="content.tilte">
        <Content
          :title="content.title"
          :description="content.description"
        ></Content></div
    ></span>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "../components/Footer";
import Content from "@/components/Content";
import { ParticlesBg } from "particles-bg-vue";
import { mapGetters } from "vuex";
export default {
  components: {
    Footer,
    ParticlesBg,
    Content,
  },
  data: function() {
    return {
      contents: [],
      contents2: [],
    };
  },
  mounted() {
    this.getAllContent();
  },
  methods: {
    async getAllContent() {
      this.contents = [];
      try {
        await this.$store.dispatch("fetchContent");
        let lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "pt";
        for (let i = 0; i < this.getContent.data.length; i++) {
          if (this.getContent.data[i].page === 2) {
            let content = {
              id_content: this.getContent.data[i].id_content,
              title: lang === "pt" ? this.getContent.data[i].title : this.getContent.data[i].title_en,
              description: lang === "pt" ? this.getContent.data[i].description : this.getContent.data[i].description_en,
              img: this.img,
            };
            this.contents.push(content);          }
        }
        if (this.contents.length > 5) {
          for (let i = 5; i < this.contents.length; i++) {
            this.contents2.push(this.contents[i]);
          }
        }
      } catch (err) {
        this.$router.push({ name: "Error" });
      }
    },
  },
  computed: { ...mapGetters(["getContent"]) },
};
</script>

<style scoped>
#cards {
  padding: 50px;
}
.card-img-top {
  padding: 60px 60px 40px 60px;
}
#services {
  border: 2px solid black;
}
.circle {
  padding-top: 50px;
  padding-bottom: 50px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

#typesOutsourcing {
  padding: 50px;
}

#outsourcing {
  background-color: transparent !important;
  border: 0px;
}
.vl {
  border-left: 6px solid #f7941e;
  height: 350px;
  position: absolute;
  left: 50%;
  margin-left: 13px;
}

#cards .card {
  background: #fff;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);
  transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
}
#particles-bg {
  position: fixed;
  /* fill the entire page */
  width: 100%;
  height: 100%;
  /* remove the space along the edges */
  margin: 0;
  padding: 0;
  /* position it to start at the top of the page */
  top: 0;
  /* put it behind other content */
  z-index: -1;
}
p {
  padding-top: 10px;
  font-size: 18px;
  font-family: "Roboto", sans-serif;
  font-weight: 300;
}
h3 {
  font-size: 35px;
  text-align: center;
  font-family: "Barlow", sans-serif;
  font-weight: 500;
}

@media (max-width: 1000px) {
  #introduction {
    padding: 80px 10px 20px 10px;
    text-align: center;
    font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
      "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
    font-size: 20px;
  }
  #cards {
    padding: 20px 0px 20px 0px;
  }
  .card-img-top {
    padding: 60px 60px 40px 60px;
  }
  #services {
    margin-top: 50px;
    border: 2px solid black;
  }
  .circle {
    padding: 40px 0px 40px 0px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  #typesOutsourcing {
    padding: 50px 0px 0px 30px;
    background-color: none;
  }

  #outsourcing {
    background-color: transparent !important;
    border: 0px;
  }
  .vl {
    border-left: 0px solid #f7941e;
  }
  hr {
    width: 100%;
    text-align: center;
    border: 3px solid;
    color: #f7941e;
  }
  .col-centered {
    float: none;
    margin: 0 auto;
  }
}
</style>
